import React, { Component } from "react"
import intl from "react-intl-universal"
import { Layout, InputNumber, Alert, Button } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import "./create.css"
import { getPageQuery } from "../../../common/util/util"
import { pageCreateOrderInit, createOrder } from "../../../api/console/order/Order"

const { Header, Footer, Content } = Layout


const getContent = function (item) {
    if (item === 1) {
        return (<span className="color-green6"><CheckOutlined /></span>)
    } else if (item === 0) {
        return (<span className="color-red6"><CloseOutlined /></span>)
    } else {
        return (<div dangerouslySetInnerHTML={{ __html: item }}></div>)
    }
}

const COMBO_FREE = 5
const COMBO_BEGIN = 6
const COMBO_A = 1
const COMBO_B = 2
const COMBO_C = 3
const COMBO_D = 4

class CreateOrder extends Component {

    constructor(props) {
        super(props)
        this.state = {
            initDone: false,
            buyBtnDisabled: false,
            comboId: getPageQuery().combo,
            comboMap: {},
            comboShowMap: {},
            comboIdList: [],
            comboList: []
        }

        this.onChangeNumber = this.onChangeNumber.bind(this)
        this.onChangeCombo = this.onChangeCombo.bind(this)
        this.addOrder = this.addOrder.bind(this)
    }


    componentWillMount () {
        this.pageInit()
    }

    pageInit () {
        pageCreateOrderInit().then((res) => {
            if (res.code === 0) {
                this.setState({
                    initDone: true,
                    orderNum: 1,
                    comboMap: res.data.comboMap,
                    comboShowMap: res.data.comboShowMap,
                    comboIdList: res.data.comboIdList,
                    comboList: res.data.comboList,
                })
            }
        }, (error) => {
            console.log("get response failed!")
        }
        )
    }



    onChangeNumber (value) {
        this.setState({
            orderNum: value
        })
    }


    onChangeCombo (comboId) {
        this.setState({
            comboId: comboId
        })
    }

    /**
     *
     *
     */
    addOrder () {
        const { comboId, orderNum } = this.state
        let params = {
            comboId: comboId,
            orderNum: orderNum
        }
        this.setState({
            buyBtnDisabled: true,
        })
        createOrder(params).then((res) => {
            if (res.code === 0) {
                window.location.href = "/#/order/pay?orderId=" + res.data.orderId

            }
        }, (error) => {
            console.log("get response failed!")
            this.setState({
                buyBtnDisabled: false,
            })
        }
        )
    }


    render () {
        const { comboId, comboList, comboMap, orderNum, buyBtnDisabled } = this.state
        let that = this
        // const dataFirstRow = [
        //     intl.get('order.create_row1'),
        //     intl.get('order.create_row2'),
        //     intl.get('order.create_row3'),
        //     intl.get('order.create_row4'),
        //     intl.get('order.create_row5'),
        //     intl.get('order.create_row6'),
        //     intl.get('order.create_row7'),
        //     intl.get('order.create_row8'),
        //     <div>{intl.get('order.create_row9')}<br /><br /></div>,
        //     intl.get('order.create_row10'),
        //     intl.get('order.create_row11'),
        //     intl.get('order.create_row12'),
        //     intl.get('order.create_row13'),
        // ]

        return (
            this.state.initDone &&
            <Layout style={{ position: "inherit" }}>
                <Header className="welcome" style={{ padding: "0 20px" }}>
                    <div >
                        <div style={{ display: 'flex', justifyContent: "space-between" }}>
                            <div className="font-20-l28">
                                {intl.get('order.create_title')}
                            </div>
                        </div>
                    </div>
                </Header>

                <Content style={{ overflow: "auto", marginBottom: "100px" }}>
                    <div className="content">
                        <div style={{ padding: '16px 20px' }}>

                            <Alert message={<div>{intl.get('order.create_alert')}：<span>13581621843</span></div>} type="info" showIcon />
                            <div style={{ marginTop: "16px" }}></div>
                            <div className="row" style={{ marginLeft: '0px', marginRight: '0px' }}>
                                <div className="w-100">
                                    <div className="bg-white mb-3">
                                        <div className="a-card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="font-16-l24">{intl.get('order.combo_select')}</div>
                                                <div className="font-LH-14 color-black-85 font-weight-normal">

                                                </div>
                                            </div>
                                        </div>

                                        <div className="px-4 p-3">
                                            {comboList.map(function (col, index) {
                                                return (
                                                    <div className="box">
                                                        <div className="box-col">
                                                            <div className="box-col-block">
                                                                <div className="block-body font-12-l20-w400-c8 custom-list-combo-title">
                                                                    {col.title}
                                                                </div>
                                                            </div>
                                                            <div className={
                                                                "box-col-block font-14-l22-w400-v85 box-col-block-border "
                                                                + (index === 0 ? 'first-title ' : ' ')
                                                                + (comboId === COMBO_FREE ? " combo-click" : " ")
                                                                + (comboId === COMBO_FREE && index === 0 ? ' first-title-click' : ' ')
                                                                + (comboId === COMBO_FREE && index === (comboList.length - 1) ? ' last-block-click' : ' ')
                                                            }
                                                                onClick={() => that.onChangeCombo(COMBO_FREE)}
                                                            >
                                                                <div className="block-body text-center">
                                                                    {getContent(col[COMBO_FREE])}
                                                                </div>
                                                            </div>
                                                            <div className={
                                                                "box-col-block font-14-l22-w400-v85 box-col-block-border "
                                                                + (index === 0 ? 'first-title ' : ' ')
                                                                + (comboId === COMBO_BEGIN ? " combo-click" : " ")
                                                                + (comboId === COMBO_BEGIN && index === 0 ? ' first-title-click' : ' ')
                                                                + (comboId === COMBO_BEGIN && index === (comboList.length - 1) ? ' last-block-click' : ' ')
                                                            }
                                                                onClick={() => that.onChangeCombo(COMBO_BEGIN)}
                                                            >
                                                                <div className="block-body text-center">
                                                                    {getContent(col[COMBO_BEGIN])}
                                                                </div>
                                                            </div>
                                                            <div className={
                                                                "box-col-block font-14-l22-w400-v85 box-col-block-border "
                                                                + (index === 0 ? 'first-title ' : ' ')
                                                                + (comboId === COMBO_A ? " combo-click" : " ")
                                                                + (comboId === COMBO_A && index === 0 ? ' first-title-click' : ' ')
                                                                + (comboId === COMBO_A && index === (comboList.length - 1) ? ' last-block-click' : ' ')
                                                            }
                                                                onClick={() => that.onChangeCombo(COMBO_A)}
                                                            >
                                                                <div className="block-body text-center">
                                                                    {getContent(col[COMBO_A])}
                                                                </div>
                                                            </div>
                                                            <div className={
                                                                "box-col-block font-14-l22-w400-v85 box-col-block-border "
                                                                + (index === 0 ? 'first-title ' : ' ')
                                                                + (comboId === COMBO_B ? " combo-click" : " ")
                                                                + (comboId === COMBO_B && index === 0 ? ' first-title-click' : ' ')
                                                                + (comboId === COMBO_B && index === (comboList.length - 1) ? ' last-block-click' : ' ')
                                                            }
                                                                onClick={() => that.onChangeCombo(COMBO_B)}
                                                            >
                                                                <div className="block-body text-center">
                                                                    {getContent(col[COMBO_B])}
                                                                </div>
                                                            </div>
                                                            <div className={
                                                                "box-col-block font-14-l22-w400-v85 box-col-block-border "
                                                                + (index === 0 ? 'first-title ' : ' ')
                                                                + (comboId === COMBO_C ? " combo-click" : " ")
                                                                + (comboId === COMBO_C && index === 0 ? ' first-title-click' : ' ')
                                                                + (comboId === COMBO_C && index === (comboList.length - 1) ? ' last-block-click' : ' ')
                                                            }
                                                                onClick={() => that.onChangeCombo(COMBO_C)}
                                                            >
                                                                <div className="block-body text-center ">
                                                                    {getContent(col[COMBO_C])}
                                                                </div>
                                                            </div>
                                                            <div className={
                                                                "box-col-block font-14-l22-w400-v85 box-col-block-border "
                                                                + (index === 0 ? 'first-title ' : ' ')
                                                                + (comboId === COMBO_D ? " combo-click" : " ")
                                                                + (comboId === COMBO_D && index === 0 ? ' first-title-click' : ' ')
                                                                + (comboId === COMBO_D && index === (comboList.length - 1) ? ' last-block-click' : ' ')
                                                            }
                                                                onClick={() => that.onChangeCombo(COMBO_D)}
                                                            >
                                                                <div className="block-body text-center ">
                                                                    {getContent(col[COMBO_D])}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Content>

                <Footer style={{
                    padding: "0 0",
                    position: "sticky",
                    width: "100%",
                    bottom: "48px",
                    height: "94px",
                    boxShadow: "0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)",
                    background: "#FFF",
                }}>

                    <div className="d-flex justify-content-between align-items-center" style={{
                        padding: "16px 48px",
                    }}>
                        <div className="d-flex align-items-center">
                            <div>{intl.get('order.create_time')}：1</div>
                            <div className="align-items-center" style={{ marginLeft: "80px", display: 'none' }}>
                                <div>{intl.get('order.create_num')}:</div>
                                <div style={{ marginLeft: "16px" }}>
                                    <InputNumber min={1} max={10} value={orderNum} onChange={this.onChangeNumber} />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="font-14-l22-w400-B">
                                {intl.get('order.create_amount')}：
                            </div>
                            <div style={{ marginLeft: "20px" }}>
                                <div className="font-30-l40-w500-red6">{comboMap[comboId].price * orderNum}</div>
                                <div className="font-14-l22-w400-N6">{intl.get('order.create_price')}：{comboMap[comboId].price * orderNum}</div>
                            </div>
                            <Button style={{ marginLeft: "32px" }} type="primary" disabled={buyBtnDisabled} onClick={that.addOrder} danger>{intl.get('order.create_buy')}</Button>
                        </div>
                    </div>
                </Footer>
            </Layout>
        )
    }
}

export default CreateOrder
